// extracted by mini-css-extract-plugin
module.exports = {"modalText":"acceptAndSignModal_modalText__KVELZ","buttonsContainer":"acceptAndSignModal_buttonsContainer__MvOH6","link":"acceptAndSignModal_link__5E3k8"};